import { useState } from "react";
const DebounceBtn = props => {
    const { className = '', onClick, isDisabled = false} = props;
    const [disabled, setDisabled] = useState(false)
    const handleBtnClick = () => {
        if (isDisabled || disabled) return;
        setDisabled(true)
        onClick();
        setTimeout(() => { setDisabled(false) }, 2000);
    }
    return (
        <button className={className + (isDisabled ? ' disabled' : '')} onClick={handleBtnClick}>
            {props.children}
        </button>
    )
}

export default DebounceBtn;